<template>
  <VSnackbar
    v-model="isSnackbarVisible"
    :location="position"
    :timeout="timeout"
    :color="fillColor"
  >
    {{ title }}
    <VDivider />
    <p v-html="msg" />
  </VSnackbar>
</template>

<script setup>
import { useToasterStore } from '@/store/ToasterStore'

const { position, fillColor, timeout, title, msg, isSnackbarVisible  } = storeToRefs(useToasterStore())
</script>
